import {
  InteriorCenter,
  InteriorLeft,
  InteriorRight,
  OrdersFormViewModel,
  WorkflowOrderInputModel,
} from '@ail/orders-api'

const KNOWN_CONDITION_KEYS = [
  'returnContractInteriorLeft',
  'returnContractInteriorCenter',
  'returnContractInteriorRight',
  'returnLogisticId',
  'formId',
]

export function WorkflowOrderConditionsEdit(props: {
  order: WorkflowOrderInputModel
  forms: OrdersFormViewModel[]
  onChange: (value: WorkflowOrderInputModel) => void
}) {
  const getConditionOptions = (key: string) => {
    let result: string[] = []
    if (key === 'returnContractInteriorLeft') {
      result = Object.values(InteriorLeft)
    } else if (key === 'returnContractInteriorCenter') {
      result = Object.values(InteriorCenter)
    } else if (key === 'returnContractInteriorRight') {
      result = Object.values(InteriorRight)
    } else {
      for (const form of props.forms) {
        for (const field of form.formFields) {
          if (field.name !== key) continue
          for (const option of field.options) {
            if (option.value && !result.includes(option.value)) {
              result.push(option.value)
            }
          }
        }
      }
    }
    return result
  }

  const updateConditionKey = (oldKey: string, newKey: string) => {
    const updated: Record<string, string> = {}
    for (const [k, v] of Object.entries(props.order.conditions)) {
      updated[k === oldKey ? newKey : k] = v
    }
    props.onChange({ ...props.order, conditions: updated })
  }

  const removeCondition = (key: string) => {
    const updated = { ...props.order.conditions }
    delete updated[key]
    props.onChange({ ...props.order, conditions: updated })
  }

  const updateConditionValue = (conditionKey: string, conditionIdx: number, value: string) => {
    const values = [...(props.order.conditions[conditionKey] ?? [])]
    values[conditionIdx] = value
    props.onChange({ ...props.order, conditions: { ...props.order.conditions, [conditionKey]: values } })
  }

  const addConditionValue = (conditionKey: string) => {
    const values = [...(props.order.conditions[conditionKey] ?? []), '']
    props.onChange({ ...props.order, conditions: { ...props.order.conditions, [conditionKey]: values } })
  }

  const removeConditionValue = (conditionKey: string, conditionIdx: number) => {
    const values = (props.order.conditions[conditionKey] ?? []).filter((_: never, i: number) => i !== conditionIdx)
    props.onChange({ ...props.order, conditions: { ...props.order.conditions, [conditionKey]: values } })
  }

  return (
    <table className="workflow-order-conditions-edit" border={1}>
      <tbody>
        <tr>
          <th onClick={() => props.onChange({ ...props.order, conditions: { ...props.order.conditions, '': [] } })}>
            <i className="icon-add" style={{ cursor: 'pointer', color: 'green' }} />
          </th>
        </tr>
        {Object.entries(props.order.conditions as Record<string, string[]>).map(([conditionKey, conditionValues]) => (
          <tr key={conditionKey}>
            <td>
              <table border={1}>
                <tbody>
                  <tr>
                    <th onClick={() => removeCondition(conditionKey)}>
                      <i className="icon-close" style={{ cursor: 'pointer', color: 'red' }} />
                    </th>
                    <th onClick={() => addConditionValue(conditionKey)}>
                      <i className="icon-add" style={{ cursor: 'pointer', color: 'green' }} />
                    </th>
                    {conditionValues.map((_, i) => (
                      <th key={i} onClick={() => removeConditionValue(conditionKey, i)}>
                        <i className="icon-close" style={{ cursor: 'pointer', color: 'red' }} />
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <td>
                      <input
                        list={`condition-keys-${props.order.form.name}`}
                        value={conditionKey}
                        onChange={(e) => updateConditionKey(conditionKey, e.target.value)}
                        style={{ width: 200 }}
                      />
                      <datalist id={`condition-keys-${props.order.form.name}`}>
                        {KNOWN_CONDITION_KEYS.map((k) => (
                          <option key={k} value={k} />
                        ))}
                      </datalist>
                    </td>
                    <td>==</td>
                    {conditionValues.map((conditionValue, conditionIdx) => (
                      <td key={conditionIdx}>
                        <input
                          list={`conditions_${props.order.form.name}_${conditionKey}_${conditionIdx}`}
                          value={conditionValue}
                          onChange={(e) => updateConditionValue(conditionKey, conditionIdx, e.target.value)}
                        />
                        <datalist id={`conditions_${props.order.form.name}_${conditionKey}_${conditionIdx}`}>
                          {getConditionOptions(conditionKey).map((o) => (
                            <option key={o} value={o} />
                          ))}
                        </datalist>
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
